import { cn } from '@/lib/utils'
import { Card } from '@/components/ui/card'
import { WarningCircle, CheckCircle } from '@phosphor-icons/react'
import type { Metric } from '../../types'

interface BottleneckCardProps {
  bottleneck: string
  bottleneckMetric?: Metric
}

export function BottleneckCard({ bottleneck, bottleneckMetric }: BottleneckCardProps) {
  const severity = bottleneckMetric?.status === 'danger' ? 'danger'
    : bottleneckMetric?.status === 'warning' ? 'warning'
    : 'ok'

  return (
    <Card
      className={cn(
        'border rounded-2xl p-4',
        severity === 'danger' && 'bg-destructive/[0.06] border-destructive/30',
        severity === 'warning' && 'bg-warning/[0.06] border-warning/30',
        severity === 'ok' && 'bg-success/[0.06] border-success/30',
      )}
    >
      <div className="flex items-start gap-3">
        {severity === 'ok' ? (
          <CheckCircle weight="fill" className="w-4 h-4 mt-0.5 flex-shrink-0 text-success" />
        ) : (
          <WarningCircle
            weight="fill"
            className={cn(
              'w-4 h-4 mt-0.5 flex-shrink-0',
              severity === 'danger' && 'text-destructive',
              severity === 'warning' && 'text-warning',
            )}
          />
        )}
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.06em] text-muted-foreground">
            Gargalo Principal
          </p>
          <p className="text-sm font-medium text-foreground mt-0.5">{bottleneck}</p>
          {bottleneckMetric?.description && (
            <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
              {bottleneckMetric.description}
            </p>
          )}
        </div>
      </div>
    </Card>
  )
}
